import { createFileRoute } from '@tanstack/react-router';

import { AgentDetailPage } from '../agent/detail/AgentDetailPage';

export const Route = createFileRoute('/_app/agents/$id')({
    component: AgentDetailPage,
});
